export default "__VITE_ASSET__e20f698d__"